(function () {
  'use strict';

  var MATCHES = {
    ro:   { handle: 'ultrapure-reverse-osmosis-system', label: 'ULTRAPURE Reverse Osmosis',        reason: 'Bottled-quality drinking water from the tap.' },
    soft: { handle: 'ultrapure-soft-water-system',      label: 'ULTRAPURE Soft Water Whole House', reason: 'Whole-home filtration for soft-water areas.' },
    hard: { handle: 'ultrapure-hard-water-system',      label: 'ULTRAPURE Hard Water Whole House', reason: 'Whole-home filtration plus scale protection.' }
  };

  function pick(source, hardness, scope) {
    if (scope === 'drinking') return MATCHES.ro;
    if (hardness === 'hard') return MATCHES.hard;
    return MATCHES.soft;
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var form = document.querySelector('[data-ultrapure-quiz]');
    if (!form) return;
    var result = document.querySelector('[data-ultrapure-quiz-result]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      var match = pick(data.get('source'), data.get('hardness'), data.get('scope'));
      if (!match) return;

      result.innerHTML =
        '<div class="ultrapure-v2__quiz-match">' +
          '<p class="ultrapure-v2__quiz-match-kicker">Your match:</p>' +
          '<h3 class="ultrapure-v2__quiz-match-title">' + match.label + '</h3>' +
          '<p class="ultrapure-v2__quiz-match-reason">' + match.reason + '</p>' +
          '<a class="ultrapure-v2__btn ultrapure-v2__btn--primary" href="/products/' + match.handle + '">View product →</a>' +
        '</div>';
      result.removeAttribute('hidden');

      var card = document.querySelector('[data-ultrapure-product="' + match.handle + '"]');
      if (card) {
        card.classList.add('ultrapure-v2__product--highlight');
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (window.dataLayer) {
        window.dataLayer.push({ event: 'ultrapure_quiz_match', ultrapure_match: match.handle });
      }
    });
  });

  onReady(function () {
    document.querySelectorAll('[data-ultrapure-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-ultrapure-slider-track]');
      var prev = wrap.querySelector('[data-ultrapure-slider-prev]');
      var next = wrap.querySelector('[data-ultrapure-slider-next]');
      var close = wrap.querySelector('[data-ultrapure-slider-close]');
      if (!track) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
      function openFs() { wrap.classList.add('is-fullscreen'); document.body.classList.add('ultrapure-v2-lock'); }
      function closeFs() { wrap.classList.remove('is-fullscreen'); document.body.classList.remove('ultrapure-v2-lock'); }
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
      wrap.querySelectorAll('[data-ultrapure-slider-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (wrap.classList.contains('is-fullscreen')) { closeFs(); } else { openFs(); }
        });
      });
      close && close.addEventListener('click', closeFs);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wrap.classList.contains('is-fullscreen')) closeFs();
      });
    });
  });
})();

/* ───── V2 product page — variant buttons + thumbnail swap + qty + PDF tabs ───── */
(function () {
  'use strict';
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var hero = document.querySelector('[data-ultrapure-v2-section="product-hero"]');
    if (hero) {
      /* Variant pills */
      var variantWrap = hero.querySelector('[data-ph-variants]');
      var hiddenInput = hero.querySelector('[data-ph-variant-id]');
      var priceCurrent = hero.querySelector('[data-ph-price-current]');
      var priceDisplay = hero.querySelector('[data-ph-price-display]');
      if (variantWrap && hiddenInput) {
        variantWrap.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-ph-variant]');
          if (!btn || btn.disabled) return;
          variantWrap.querySelectorAll('[data-ph-variant]').forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          hiddenInput.value = btn.dataset.variantId;
          if (priceCurrent && btn.dataset.price) priceCurrent.textContent = btn.dataset.price;
          if (priceDisplay) {
            var compareVal = btn.dataset.comparePrice;
            var existing = priceDisplay.querySelector('[data-ph-price-compare]');
            if (compareVal && compareVal.length) {
              if (existing) existing.textContent = compareVal;
              else {
                var s = document.createElement('span');
                s.className = 'ultrapure-v2__ph-price-compare';
                s.setAttribute('data-ph-price-compare', '');
                s.textContent = compareVal;
                priceDisplay.appendChild(s);
              }
            } else if (existing) existing.remove();
          }
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      /* Thumbnail swap */
      var gallery = hero.querySelector('[data-ph-gallery]');
      if (gallery) {
        var mainImg = gallery.querySelector('[data-ph-gallery-main-img]');
        gallery.addEventListener('click', function (e) {
          var thumb = e.target.closest('[data-ph-thumb]');
          if (!thumb || !mainImg) return;
          if (thumb.dataset.fullSrc) mainImg.src = thumb.dataset.fullSrc;
          if (thumb.dataset.fullSrcset) mainImg.srcset = thumb.dataset.fullSrcset;
          gallery.querySelectorAll('[data-ph-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      }

      /* Thumbnail scroll arrows */
      var thumbsWrap = hero.querySelector('[data-ph-thumbs-wrap]');
      if (thumbsWrap) {
        var thumbsTrack = thumbsWrap.querySelector('[data-ph-thumbs]');
        var thumbsPrev = thumbsWrap.querySelector('[data-ph-thumbs-prev]');
        var thumbsNext = thumbsWrap.querySelector('[data-ph-thumbs-next]');
        if (thumbsTrack && thumbsPrev && thumbsNext) {
          var stepDistance = function () {
            /* Scroll by 3 thumbs worth (each ~72px + 8px gap = 80px) */
            return 80 * 3;
          };
          var updateArrows = function () {
            var atStart = thumbsTrack.scrollLeft <= 1;
            var atEnd = thumbsTrack.scrollLeft + thumbsTrack.clientWidth >= thumbsTrack.scrollWidth - 1;
            var overflows = thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 1;
            thumbsPrev.hidden = !overflows || atStart;
            thumbsNext.hidden = !overflows || atEnd;
          };
          thumbsPrev.addEventListener('click', function () {
            thumbsTrack.scrollBy({ left: -stepDistance(), behavior: 'smooth' });
          });
          thumbsNext.addEventListener('click', function () {
            thumbsTrack.scrollBy({ left: stepDistance(), behavior: 'smooth' });
          });
          thumbsTrack.addEventListener('scroll', updateArrows, { passive: true });
          window.addEventListener('resize', updateArrows);
          /* Initial state + after images settle */
          updateArrows();
          setTimeout(updateArrows, 200);
        }
      }

      /* Quantity +/- */
      var qtyInput = hero.querySelector('[data-ph-qty]');
      var qtyUp = hero.querySelector('[data-ph-qty-up]');
      var qtyDown = hero.querySelector('[data-ph-qty-down]');
      if (qtyInput && qtyUp && qtyDown) {
        qtyUp.addEventListener('click', function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        qtyDown.addEventListener('click', function () {
          var v = (parseInt(qtyInput.value, 10) || 1) - 1;
          if (v < 1) v = 1;
          qtyInput.value = v;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    /* Installation PDF tabs — toggle the WRAP, which holds both the
       iframe and the "open in new tab" link, so the link hides
       together with the inactive iframe. */
    document.querySelectorAll('[data-pdf-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-pdf-tab]');
      var frameWraps = wrap.querySelectorAll('[data-pdf-frame-wrap]');
      wrap.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-pdf-tab]');
        if (!tab) return;
        var idx = tab.dataset.pdfIndex;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        frameWraps.forEach(function (fw) {
          fw.hidden = (fw.dataset.pdfIndex !== idx);
        });
      });
    });

    /* FBT carousel (only rendered when 4+ products linked) */
    document.querySelectorAll('[data-ph-fbt-wrap]').forEach(function (fbtWrap) {
      var fbtTrack = fbtWrap.querySelector('[data-ph-fbt-track]');
      var fbtPrev = fbtWrap.querySelector('[data-ph-fbt-prev]');
      var fbtNext = fbtWrap.querySelector('[data-ph-fbt-next]');
      if (!fbtTrack || !fbtPrev || !fbtNext) return;
      var fbtStep = function () {
        var firstCard = fbtTrack.querySelector('.ultrapure-v2__fbt-card');
        var cardW = firstCard ? firstCard.offsetWidth : 260;
        /* Scroll by one card width plus gap (~16px) */
        return cardW + 16;
      };
      var fbtUpdateArrows = function () {
        var atStart = fbtTrack.scrollLeft <= 1;
        var atEnd = fbtTrack.scrollLeft + fbtTrack.clientWidth >= fbtTrack.scrollWidth - 1;
        var overflows = fbtTrack.scrollWidth > fbtTrack.clientWidth + 1;
        fbtPrev.hidden = !overflows || atStart;
        fbtNext.hidden = !overflows || atEnd;
      };
      fbtPrev.addEventListener('click', function () {
        fbtTrack.scrollBy({ left: -fbtStep(), behavior: 'smooth' });
      });
      fbtNext.addEventListener('click', function () {
        fbtTrack.scrollBy({ left: fbtStep(), behavior: 'smooth' });
      });
      fbtTrack.addEventListener('scroll', fbtUpdateArrows, { passive: true });
      window.addEventListener('resize', fbtUpdateArrows);
      fbtUpdateArrows();
      setTimeout(fbtUpdateArrows, 200);
    });
  });
})();
